export const BRAND = {
  name: "GradQuest Sol",
  tagline: "Guidance that empowers. Journeys that inspire.",
  heroLine: "Where Ambition Meets Opportunity.",
  phones: ["9953159202", "9717489303"],
  email: "gradquestnoida@gmail.com",
  address:
    "Office no. RT100, Ground Floor, Block C – Urbtech Trade Centre, Sector 132, Noida",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/programmes", label: "Programmes" },
  { to: "/about", label: "About" },
  { to: "/founders-note", label: "Founder's Note" },
  { to: "/cofounders-note", label: "Co-Founder's Note" },
  { to: "/privacy-policy", label: "Privacy" },
];

export const VALUES = [
  {
    key: "empowering",
    title: "Empowering Learners",
    body: "We nurture curiosity and confidence, turning every student into an independent, ambitious thinker.",
  },
  {
    key: "opening",
    title: "Opening Doors",
    body: "From tests to admissions to visas — we open the doors that lead to global classrooms.",
  },
  {
    key: "impact",
    title: "Creating Impact",
    body: "Careers built, families reassured, journeys completed. Our work is measured in the lives it shapes.",
  },
];

export const PROGRAMMES = [
  {
    slug: "ielts",
    title: "IELTS",
    kicker: "Test Prep",
    body: "Structured coaching across all four modules — Listening, Reading, Writing, Speaking. Diagnostic tests, band-score strategy, and mock rehearsals until fluency feels natural.",
    highlights: [
      "All 4 modules covered",
      "Band score improvement plans",
      "Speaking rehearsals & feedback",
      "Full-length mock tests",
    ],
  },
  {
    slug: "sat",
    title: "SAT",
    kicker: "Test Prep",
    body: "Concept-first mathematics, evidence-based reading, and rigorous writing craft. Timed practice, error journals, and adaptive strategies for consistent gains.",
    highlights: [
      "Concept building & problem sets",
      "Reading & writing frameworks",
      "Timed mock tests",
      "Error analysis reviews",
    ],
  },
  {
    slug: "ibig",
    title: "IB / IG Courses",
    kicker: "School Curriculum",
    body: "IB Diploma and IGCSE subject tutoring by seasoned mentors. IA and EE guidance, examiner-style feedback, and revision cycles calibrated to school calendars.",
    highlights: [
      "IB DP subject tutoring",
      "IGCSE preparation",
      "IA & EE research support",
      "Predicted-grade improvement",
    ],
  },
  {
    slug: "languages",
    title: "Foreign Languages",
    kicker: "Communication",
    body: "Conversational fluency and certification tracks for French, German, Spanish and more. Speak with confidence — for study, for work, for the world.",
    highlights: [
      "Conversational fluency tracks",
      "Certification preparation",
      "Small batch immersion",
      "Cultural context modules",
    ],
  },
  {
    slug: "study-abroad",
    title: "Study Abroad Planning",
    kicker: "End-to-End",
    body: "From shortlist to send-off. Universities matched to your ambitions, applications crafted line by line, visas guided step by step, and support that continues after you land.",
    highlights: [
      "University shortlisting",
      "Application & essay support",
      "Visa documentation",
      "Post-arrival assistance",
    ],
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Career Counselling & University Shortlisting",
    body: "Aptitude, ambition and affordability — mapped to universities that fit you like a well-tailored coat.",
  },
  {
    n: "02",
    title: "Application Support",
    body: "SOPs, LORs, essays and forms — crafted, refined and submitted without a comma out of place.",
  },
  {
    n: "03",
    title: "Admission Confirmation",
    body: "Offer letters reviewed, deposits guided, enrolment secured with clarity at every step.",
  },
  {
    n: "04",
    title: "Visa Guidance",
    body: "Documentation checklists, financial statements, mock interviews — visa outcomes without surprises.",
  },
  {
    n: "05",
    title: "Pre-Departure Support",
    body: "Forex, insurance, packing lists, cultural briefings — the small details that steady big beginnings.",
  },
  {
    n: "06",
    title: "Accommodation Assistance",
    body: "Verified housing options near your campus. Contracts read, roommates matched, keys secured.",
  },
  {
    n: "07",
    title: "Post-Arrival Support",
    body: "Bank accounts, sim cards, campus onboarding — we stay in touch long after the flight lands.",
  },
];

export const WHY_US = [
  { title: "Expert Mentors", body: "Faculty drawn from top institutions and industry practice." },
  { title: "Personalised Approach", body: "Plans built around one student, never a template." },
  { title: "Proven Results", body: "Band scores lifted, admits earned, families reassured." },
  { title: "Comprehensive Support", body: "From first counselling to first day on campus." },
  { title: "Up-to-Date Strategies", body: "Curricula tuned to the latest exam patterns and admit trends." },
  { title: "Global Network", body: "University partners and alumni across continents." },
  { title: "Student-Centric Values", body: "Empathy first. Everything else follows." },
];

export const APPROACH = [
  { step: "Understand", body: "Aspirations, aptitude, background — we listen before we advise." },
  { step: "Design", body: "A study plan and admissions roadmap tailored to the student." },
  { step: "Train", body: "Rigorous coaching, mentorship and continuous feedback." },
  { step: "Deliver", body: "Applications submitted, results earned, journeys begun." },
];

export const FACULTY = [
  { name: "Faculty Name", role: "IELTS Trainer", photo: "/images/sash.png" },
  { name: "Faculty Name", role: "SAT Mentor", photo: "/images/sash.png" },
  { name: "Faculty Name", role: "IB / IG Tutor", photo: "/images/sash.png" },
  { name: "Faculty Name", role: "Study Abroad Counsellor", photo: "/images/sash.png" },
];

export const SOCIALS = [
  { name: "Instagram", href: "https://www.instagram.com/gradquestsol", icon: "instagram" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61591766213563", icon: "facebook" },
  { name: "WhatsApp", href: "https://api.whatsapp.com/send/?phone=9958959690&text=Hi!%20I%20went%20through%20your%20page%20and%20I'm%20interested%20in%20the%20programmes%20offered%20by%20GradQuest.%20I'd%20like%20to%20know%20more.", icon: "whatsapp" },
  { name: "LinkedIn", href: "#", icon: "linkedin" },
  { name: "YouTube", href: "#", icon: "youtube" },
];